<div class="dialog-block v2-active">
    <div class="dialog-layout">
        <div class="artwork">
            <img
                [src]="instance === DialogBlockInstance.LIMIT ? limitArtSrc : upgradeArtSrc"
                [alt]="instance === DialogBlockInstance.LIMIT ? 'Medidor no máximo' : 'Rato decolando'"
            />
        </div>

        <div class="content">
            <div class="copy">
                @if (instance === DialogBlockInstance.LIMIT) {
                    <h1>{{ 'shared.dialogBlock.limit.titulo' | transloco }}</h1>
                    <p>{{ 'shared.dialogBlock.limit.subtitulo' | transloco }}</p>
                    <span>{{ 'shared.dialogBlock.limit.descricao' | transloco }}</span>
                } @else {
                    <h1>{{ 'shared.upgradePlanoDialog.titulo' | transloco }}</h1>
                    <p>{{ 'shared.upgradePlanoDialog.subtitulo' | transloco }}</p>
                    <span>{{ 'shared.upgradePlanoDialog.descricao' | transloco }}</span>
                }
            </div>

            @if (instance === DialogBlockInstance.LIMIT && showExtrato) {
                <div class="usage">
                    <span class="usage-stat">
                        {{ 'shared.dialogBlock.limit.seuLimite' | transloco }}: {{ limite }}
                    </span>
                    <span class="usage-stat">
                        {{ 'shared.dialogBlock.limit.usado' | transloco }}: {{ saldo }}
                    </span>
                </div>
            }

            <div class="actions">
                <button mat-stroked-button color="secondary" (click)="cancelar()">
                    {{ 'shared.upgradePlanoDialog.fechar' | transloco }}
                </button>
                <button mat-flat-button class="upgrade-action" (click)="upgrade()">
                    {{ 'shared.upgradePlanoDialog.upgrade' | transloco }}
                </button>
            </div>
        </div>
    </div>
</div>
